import { render, staticRenderFns } from "./upkeepplanstandard.vue?vue&type=template&id=6b1e9551&"
import script from "./upkeepplanstandard.vue?vue&type=script&lang=js&"
export * from "./upkeepplanstandard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports